export default "__VITE_ASSET__ce75bcdf__"